import { API_BASE_URL } from '../config/apiConfig';

/**
 * Set admin role for a user
 * @param {string} email - User email
 * @param {object} user - Current user object with getIdToken() method
 * @returns {Promise} Response from API
 */
export const setAdminRole = async (email, user) => {
  try {
    console.log(`🔐 Setting admin role for: ${email}`);
    
    const idToken = await user.getIdToken();
    const response = await fetch(`${API_BASE_URL}/admin/set-admin-role`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to set admin role');
    }

    const data = await response.json();
    console.log(`✅ Admin role set successfully:`, data);
    return data;
  } catch (error) {
    console.error('❌ Error setting admin role:', error);
    throw error;
  }
};

/**
 * Remove admin role from a user
 * @param {string} email - User email
 * @param {object} user - Current user object with getIdToken() method
 * @returns {Promise} Response from API
 */
export const removeAdminRole = async (email, user) => {
  try {
    console.log(`🔓 Removing admin role from: ${email}`);
    
    const idToken = await user.getIdToken();
    const response = await fetch(`${API_BASE_URL}/admin/remove-admin-role`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to remove admin role');
    }

    const data = await response.json();
    console.log(`✅ Admin role removed successfully:`, data);
    return data;
  } catch (error) {
    console.error('❌ Error removing admin role:', error);
    throw error;
  }
};

/**
 * Get all users (admin only)
 * @param {object} user - Current user object with getIdToken() method
 * @returns {Promise} List of users
 */
export const getAllUsers = async (user) => {
  try {
    console.log(`📋 Fetching all users`);
    
    const idToken = await user.getIdToken();
    const response = await fetch(`${API_BASE_URL}/admin/users`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch users');
    }

    const data = await response.json();
    console.log(`✅ Retrieved ${data.users.length} users`);
    return data.users;
  } catch (error) {
    console.error('❌ Error fetching users:', error);
    throw error;
  }
};

// ✅ FIXED: Export as named object instead of anonymous default export
const adminApi = {
  setAdminRole,
  removeAdminRole,
  getAllUsers,
};

export default adminApi;